<template>
  <div class="page">
    <van-nav-bar title="AI 生成工作要点" left-arrow @click-left="$router.back()"/>
    <section><p>将综合岗位、战略承接、历史表现、待办任务和已发布外部情报生成建议。生成后仍需本人确认。</p>
      <van-radio-group v-model="cadence">
        <van-radio name="DAILY">每日要点</van-radio>
        <van-radio name="WEEKLY">每周要点</van-radio>
      </van-radio-group>
      <van-button block type="danger" :loading="loading" @click="generate">生成并进入确认</van-button>
    </section>
  </div>
</template>
<script>import api from '@/utils/coreapi';

export default {
  data() {
    return {cadence: 'DAILY', loading: false}
  }, methods: {
    async generate() {
      this.loading = true;
      try {
        await api.generateWorkPoints({cadence: this.cadence, periodStart: new Date().toISOString().slice(0, 10)});
        this.$toast.success('工作要点已生成');
        this.$router.replace({name: 'EfficiencyWorkPoints'})
      } catch (e) {
        this.$toast.fail(e.message)
      } finally {
        this.loading = false
      }
    }
  }
};</script>
<style scoped>.page {
  min-height: 100vh;
  background: #f6f7fb
}

.page section {
  margin: .28rem;
  padding: .34rem;
  background: #fff;
  border-radius: .18rem
}

.page p {
  margin: 0 0 .28rem;
  color: #747789;
  font-size: .27rem;
  line-height: 1.65
}

.van-radio {
  margin: .22rem 0
}

.van-button {
  margin-top: .35rem
}</style>



// WEBPACK FOOTER //
// src/views/efficiency/WorkPointGenerate.vue